import React, { useCallback } from 'react';
import { login } from 'requests/rest/login';
import LoginPage from './LoginPage';
import { data } from 'hudl-base';
import { startPasswordReset } from 'requests/rest/startPasswordReset';
import g11n from 'hudl-g11n';

const ConnectedApp = () => {
  const forward = data.getNullable('forward');
  const error = data.getNullable('error');
  const initialError = parseError(error);

  const onLogin = useCallback(
    (username: string, password: string, rememberMe: boolean) => login(username, password, rememberMe, forward),
    [forward],
  );
  const onStartPasswordReset = useCallback((email: string) => startPasswordReset(email), []);

  return (
    <LoginPage
      forward={forward}
      initialError={initialError}
      onLogin={onLogin}
      onStartPasswordReset={onStartPasswordReset}
    />
  );
};

// Make sure this error has a translation key, and translate it
const parseError = (error: string | null): string | undefined => {
  if (!error) {
    return undefined;
  }

  const i18nKeys = Object.keys(g11n.messages) || [];
  if (i18nKeys.indexOf(error) === -1) {
    return undefined;
  }

  return g11n.format(error);
};

export default ConnectedApp;
